// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sHm0","buttons":"styles_buttons__3aUFI"};